<template>
  <VanPopup
    :show="show"
    @update:show="emit('update:show', $event)"
    position="bottom"
    teleport="body"
    :z-index="zIndex"
    @click-overlay="onCancel"
    safe-area-inset-top
  >
    <VanPicker
      v-model="active"
      :columns="options"
      @cancel="onCancel"
      @confirm="onConfirm"
      @change="onChange"
      :confirm-button-text="$t(`Buttons.confirm`)"
      :cancel-button-text="$t(`Buttons.cancel`)"
    />
  </VanPopup>
</template>

<script lang="ts" setup>
import { ref, watch, nextTick } from "vue";

const props = defineProps<{
  show: boolean;
  options: {
    text: string;
    value: any;
  }[];
  zIndex?: number;
  initialValue?: any;
}>();

const active = ref<any>();

const emit = defineEmits<{
  (event: "update:show", value: boolean): void;
  (event: "confirm", value: any): void;
  (event: "change", value: any): void;
  (event: "cancel"): void;
}>();

watch(
  () => props.show,
  (value) => {
    if (value && props.initialValue) {
      nextTick(() => {
        active.value = [props.initialValue];
      });
    }
  }
);

const onConfirm = (value: any) => {
  emit("confirm", value.selectedValues[0]);
};

const onChange = (value: any) => {
  emit("change", value.selectedValues[0]);
};

const onCancel = () => {
  emit("cancel");
  emit("update:show", false);
};
</script>
